module.exports = __webpack_public_path__ + "img/bd-bow-ama.2a20fa67.png";